/**
 * Checks if the given value can be parsed into a valid integer and meets optional constraints
 * @param {string | number | null | undefined} value - The value to check
 * @param {object} [options] - Optional constraints
 * @param {number} [options.min] - Minimum value (inclusive)
 * @param {number} [options.max] - Maximum value (inclusive)
 * @returns {boolean} True if the value is a valid integer meeting all constraints
 */
export const isValidInteger = (
  value: string | number | null | undefined,
  options: { min?: number; max?: number } = {}
): boolean => {
  if (value === null || value === undefined || value === '') {
    return false;
  }

  const num = typeof value === 'number' ? value : parseInt(value, 10);
  if (Number.isNaN(num) || !Number.isInteger(num)) {
    return false;
  }

  if (options.min !== undefined && num < options.min) {
    return false;
  }

  if (options.max !== undefined && num > options.max) {
    return false;
  }
  return true;
};

/**
 * Validates that a value is a valid CSS length or percentage string.
 * Accepts values like '50%', '100px', '1.5rem', '0', '-10px', etc.
 * @param {string} value - The value to validate
 * @returns {boolean} True if the value is a valid CSS length/percentage
 */
export const isValidCssMeasurement = (value: string): boolean => {
  if (!value || typeof value !== 'string') return false;
  return /^-?\d+(\.\d+)?(px|%|rem|em|vh|vw|vmin|vmax|ch|ex|cm|mm|in|pt|pc)?$/.test(value.trim());
};
